import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import Image from "next/image";
import { Button } from "./Button";
import { RefreshCw, Check } from "lucide-react";
export const DICEBEAR_STYLES = ["adventurer", "avataaars", "bottts", "fun-emoji", "lorelei", "notionists", "pixel-art"];
interface DicebearCustomizerProps {
  initialUrl?: string | null;
  defaultSeed: string;
  onSelect: (url: string) => void;
}
export function DicebearCustomizer(t0) {
  const $ = _c(39);
  const {
    initialUrl,
    defaultSeed,
    onSelect
  } = t0;
  const [style, setStyle] = useState(DICEBEAR_STYLES[1]);
  const [seed, setSeed] = useState(defaultSeed || "member");
  const currentUrl = `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(seed)}`;
  let t1;
  if ($[0] !== currentUrl || $[1] !== defaultSeed || $[2] !== initialUrl || $[3] !== seed || $[4] !== style) {
    t1 = initialUrl && !initialUrl.includes(style) && seed === defaultSeed ? initialUrl : currentUrl;
    $[0] = currentUrl;
    $[1] = defaultSeed;
    $[2] = initialUrl;
    $[3] = seed;
    $[4] = style;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const displayUrl = t1;
  let t2;
  if ($[6] !== onSelect || $[7] !== style) {
    t2 = () => {
      const randomSeed = Math.random().toString(36).substring(7);
      setSeed(randomSeed);
      onSelect(`https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(randomSeed)}`);
    };
    $[6] = onSelect;
    $[7] = style;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleRandomize = t2;
  let t3;
  if ($[9] !== onSelect || $[10] !== seed) {
    t3 = newStyle => {
      setStyle(newStyle);
      onSelect(`https://api.dicebear.com/7.x/${newStyle}/svg?seed=${encodeURIComponent(seed)}`);
    };
    $[9] = onSelect;
    $[10] = seed;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleStyleChange = t3;
  let t4;
  if ($[12] !== displayUrl) {
    t4 = <div className="w-24 h-24 rounded-full ring-4 ring-gray-100 dark:ring-white/10 overflow-hidden relative bg-white dark:bg-white/5"><Image src={displayUrl} alt="Custom Avatar" fill={true} className="object-cover" unoptimized={true} /></div>;
    $[12] = displayUrl;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RefreshCw className="w-3.5 h-3.5" />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== handleRandomize) {
    t6 = <Button type="button" variant="secondary" size="sm" onClick={handleRandomize} className="flex items-center gap-2 text-xs">{t5} Randomize</Button>;
    $[15] = handleRandomize;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div className="flex flex-col items-center gap-3">{t4}{t6}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <label className="text-xs font-semibold text-[#6B7280] dark:text-slate-400 uppercase tracking-[0.06em] mb-2 block">Pilih Style Karakter</label>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== handleStyleChange || $[22] !== style) {
    t9 = DICEBEAR_STYLES.map(s => <button key={s} type="button" onClick={() => handleStyleChange(s)} className={`px-3 py-1.5 text-xs font-medium rounded-lg border transition-all ${style === s ? "bg-[var(--brand-primary)]/10 dark:bg-[var(--brand-primary-bright)]/20 border-[var(--brand-primary)] dark:border-[var(--brand-primary-bright)] text-[var(--brand-primary)] dark:text-[var(--brand-primary-brighter)]" : "bg-white dark:bg-white/5 border-gray-200 dark:border-white/10 text-gray-600 dark:text-slate-300 hover:border-gray-300 dark:hover:border-white/20"}`}>{s}</button>);
    $[21] = handleStyleChange;
    $[22] = style;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <div>{t8}<div className="flex flex-wrap gap-2">{t9}</div></div>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <label className="text-xs font-semibold text-[#6B7280] dark:text-slate-400 uppercase tracking-[0.06em] mb-1.5 block">Custom Seed (Teks Bebas)</label>;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== onSelect || $[28] !== style) {
    t12 = e => {
      setSeed(e.target.value);
      onSelect(`https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(e.target.value)}`);
    };
    $[27] = onSelect;
    $[28] = style;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== seed || $[31] !== t12) {
    t13 = <div>{t11}<div className="flex gap-2"><input type="text" value={seed} onChange={t12} className="flex-1 px-3 py-2 text-sm rounded-lg border border-black/[0.08] dark:border-white/10 dark:bg-white/5 dark:text-white outline-none focus:border-[var(--brand-primary)]/40 dark:focus:border-[var(--brand-primary-bright)]/40 focus:ring-1 focus:ring-[var(--brand-primary)]/10 dark:focus:ring-[var(--brand-primary-bright)]/10" placeholder="Ketik teks acak..." /></div></div>;
    $[30] = seed;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t13) {
    t14 = <div className="flex-1 w-full space-y-4">{t10}{t13}</div>;
    $[33] = t10;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t14 || $[37] !== t7) {
    t15 = <div className="flex flex-col sm:flex-row gap-6 items-start">{t7}{t14}</div>;
    $[36] = t14;
    $[37] = t7;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}